
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dosing",
      function () {
        return require("private-next-pages/dosing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dosing"])
      });
    }
  